const percentage = (current, total) => {
  return (current / total) * 100
};

export default percentage;
